<template>
  <div class="sidebar-right">
    <div class="block__css border-bottom__sold">
      <UserInfo></UserInfo>
    </div>
    <div class="block__css scroll__div">
      <div class="border-bottom__sold calender">
        <Calendar
          :data="atts"
          :position="'left'"
        ></Calendar>
      </div>
      <!-- <div class="border-bottom__sold work">
        <div class="title__div">
          <p class="title">Sự kiện trong ngày</p>
        </div>
        <div class="list-work">
          <div
            :class="{
              'mb-0': index + 1 == mData.dataDefault.listWork.length,
              'list-work__item': true
            }"
            v-for="(item, index) in mData.dataDefault.listWork"
            :key="index"
          >
            <div class="icon-work">
              <i class="icon-isax isax-calendar-2"></i>
            </div>
            <div class="detail-work">
              <p class="title">{{item.title}}</p>
              <div class="span-bottom">
                <p class="text time">
                  {{item.timeFrom}} - {{item.timeTo}}
                </p>
              </div>
            </div>
            <div class="action-work">
              <el-image
                style="width: 4.5px;"
                src="/img/three_dots.png"
                fit="cover"></el-image>
            </div>
          </div>
        </div>
      </div> -->
      <div class="request mb-2">
        <div class="title__div">
          <p class="title">Danh sách yêu cầu:</p>
        </div>
        <div class="number-of-request__block" @click="goToNeedApprove">
          <div class="number-of-request">
            {{mData.totalRequest < 10 ? `0${mData.totalRequest}` : mData.totalRequest}}
          </div>
          <div class="icon">
            <i class="icon-isax isax-bold-archive-book"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserInfo from '../component/UserInfo'
import MethodService from '../service/MethodService'
import EmployeeRequestApi from '@/moduleApi/EmployeeRequestApi'
import Calendar from "../component/Calendar"
export default {
  components: {
    UserInfo,
    Calendar,
  },
  data() {
    return {
      currentDate: new Date(),
      dataEvent: [],
      atts: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        },
      ],
      mData: {
        totalRequest: 0,
        dataDefault: {
          listWork: [],
        },
      },
    }
  },
  methods: {
    formatDate(date) {
      return MethodService.formatDate(date, 'date')
    },
    async getTotalRequest() {
      const res = await EmployeeRequestApi.getListEmployeeRequestAll({
        sd: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1),
        ed: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0,23,59,59),
      })
      if (MethodService.getUserProfile().type == 'COMPANY') {
        this.mData.totalRequest = res.result.filter(item => item.status === 'WAITING_FOR_APPROVAL').length
      } else {
        let arrRequestNeedApprove = res.result.filter(item => item.status === 'WAITING_FOR_APPROVAL')
        let arrRequestNeedApproveByMe = arrRequestNeedApprove.filter(item => {
          return item.approval_users.find(user => {
             return (user.approval_user_id === MethodService.getUserProfile().id) && (user.is_approval != true)
          })
        })
        this.mData.totalRequest = arrRequestNeedApproveByMe.length
      }
    },
    goToNeedApprove(){
      this.$router.push({
        name: 'Admin-ManageRequests-RequestsWaitingForApproval',
        query: {
          tab: "NEED_APPROVAL",
          fromScreen: "CEO"
        }
      });
    },
  },
  created() {
    this.getTotalRequest()
    for (let i = 0; i < 8; i++) {
      this.mData.dataDefault.listWork.push({
        title: 'Họp phòng kinh doanh 6 tháng đầu năm và kế hoạch kinh doanh 6 tháng cuối năm',
        timeFrom: '9:00 am',
        timeTo: '11:00 pm',
      })
    }
  },
}
</script>
<style lang="scss">
.sidebar-right{
  padding-left: 15px;
  padding-right: 10px;
  position: fixed;
  z-index: 1019;
  width: var(--widthRightSidebar);
  height: 100vh;
  right: 0;
  background: #fff;
  p {
    font-family: 'roboto';
  }
  
  // Hide right sidebar on mobile/tablet devices
  @media (max-width: 1024px) {
    display: none;
  }
  
  .title__div {
    padding: 10px 0 10px 0;
    .title {
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
    }
  }
  .block__css {
    padding-right: 5px;
  }
  .calender {
    padding-bottom: 10px;
    .vc-header {
      padding: 10px 10px 0 10px;
    }
    .vc-popover-content-wrapper {
      .vc-popover-content {
        .date{
          font-size: 13px;
          padding-top: 5px;
        }
        ul {
          padding-inline-start: 15px;
          padding-inline-end: 8px;
          margin-block-end: 5px;
        }
      }
    }
  }
  .work {
    padding-right: -10px;
    .list-work {
      max-height: 190px;
      overflow-y: auto;
      margin-bottom: 10px;
      padding-right: 5px;
      .list-work__item {
        position: relative;
        display: flex;
        justify-content: flex-start;
        height: 55px;
        width: 100%;
        padding: 8px 8px 8px 0;
        .icon-work {
          margin-right: 10px;
          .icon-isax {
            &::before {
              font-size: 20px;
            }
          }
        }
        .detail-work {
          width: 190px;
          padding-right: 15px;
          .title {
            margin-top: 5px;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 5px;

            white-space: nowrap;
            width: 175px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .span-bottom {
            display: flex;
            justify-content: space-between;
            .text {
              font-weight: 400;
              font-size: 12px;
              line-height: 12px;
              display: flex;
              align-items: center;
              .dot {
                width: 5px;
                height: 5px;
                background-color: #322C2C;
                border-radius: 50%;
                display: inline-block;
                margin-right: 5px;
              }
            }
          }
        }
        .action-work {
          position: absolute;
          top: 50%;
          right: 15px;
          background-color: #F0F0F0;
          border-radius: 4px;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: translateY(-50%);
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .scroll__div {
    overflow-y: auto;
    height: calc(100vh - 265px);
  }
  .request {
    .number-of-request__block {
      &:hover {
        cursor: pointer;
      }
      background: url('/img/block__request--left.png') left top no-repeat,
                  url('/img/block__request--right.png') right bottom no-repeat,
                  #FF993A;
      border-radius: 11px;
      width: 100%;
      min-height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 17px 24px;
      .number-of-request {
        padding-left: 10px;
        font-weight: 700;
        font-size: 43px;
        line-height: 47px;
        color: #FFFFFF;
        border-left: 4px solid #FFFFFF;
      }
      .icon {
        .icon-isax {
          &::before {
            font-size: 35px;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>
